

import React from "react";
import Lottie from "lottie-react";
import TransactionLoaderGif from "../Images/loader.json";

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  color: "white",
  fontSize: "18px",
};

const TransactionLoader = ({ children, isActive, text }) => {
  return (
    <div style={{ position: "relative" }}>
      {isActive && (
        <div style={overlayStyle}>
          <Lottie style={{ height: "200px" }} animationData={TransactionLoaderGif} />
          {text && <p style={{ marginTop: "10px" }}>{text}</p>}
        </div>
      )}
      {children}
    </div>
  );
};

export default TransactionLoader;
